import axios from 'axios';
import jwtInterceptor from './jwtInterceptor';
import errorInterceptor from './errorInterceptor';

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_BASE_URI}tasks`,
    headers: {
        "Content-Type": "application/json"
    }
});

instance.interceptors.request.use(jwtInterceptor);
instance.interceptors.response.use(undefined, errorInterceptor);

// Step 5: il client ora chiama la GET per pagina (invece di consumare la lista
// completa dal SSE). I parametri accettano page=1..N, pagesize=50 (default).
// I filtri B.1.3 sono accettati ma per ora non sono passati al server -- il
// lato Delphi accetta solo idorganization + page/pagesize, e il filtraggio
// server-side dei filtri verra' aggiunto in una migration successiva.
export type ActivitiesResponse = {
    waitingflownodes?: TaskLite[];
    doingflownodes?: TaskLite[];
};

export type TaskLite = {
    idprocesstoken: number;
    idprocess: number;
    state: number;
    priorityorder?: number;
    priority_name?: string;
    [k: string]: unknown;
};

export const fetchTodo = async (
    idorganization: number,
    page: number,
    pagesize: number,
): Promise<{ waitingflownodes: TaskLite[] }> => {
    const { data } = await instance.get('canget', {
        params: { idorganization, page, pagesize },
    });
    // Il server (Delphi) ritorna { waitingflownodes: [...] } sotto FLOWNODE_WAITING_ROOT.
    // Alcune build usano direttamente la chiave di root. Normalizziamo.
    const w = (data && (data.waitingflownodes ?? data.data ?? data)) as TaskLite[] | undefined;
    return { waitingflownodes: Array.isArray(w) ? w : [] };
};

export const fetchDoing = async (
    idorganization: number,
    page: number,
    pagesize: number,
): Promise<{ doingflownodes: TaskLite[] }> => {
    const { data } = await instance.get('doing', {
        // idorganization serve alla rotta /doing per filtrare: senza, il server
        // usa 0 = tutte le organizzazioni dell'utente.
        params: { idorganization, page, pagesize },
    });
    const d = (data && (data.doingflownodes ?? data.data ?? data)) as TaskLite[] | undefined;
    return { doingflownodes: Array.isArray(d) ? d : [] };
};

// Step 6: PUT /api/tasks/order per persistere il riordino manuale del drag&drop.
export type SetOrderPayload = {
    kind: 'todo' | 'doing';
    idorganization: number;
    orderedIds: number[];
};

export const setManualOrder = async (payload: SetOrderPayload): Promise<void> => {
    await instance.put('order', payload);
};

export default instance;
